<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_NewSupplierApplication')"
    :width="$selectByLang('850px', '850px', '950px')"
    :close-on-click-modal="false"
  >
    <el-form ref="form" :model="form" :rules="rules" :label-width="$selectByLang('140px', '140px', '180px')" label-position="left" class="supplier-application-form">
      <el-row :gutter="20">
        <!-- 代码 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.cnShortName')" prop="cnShortName">
            <el-input v-model="form.cnShortName" no="cnShortName" :maxlength="64" :disabled="true" />
          </el-form-item>
        </el-col>
        <!-- 国内/国外 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_DomesticOverseas')" prop="oversea">
            <el-select v-model="form.oversea" no="oversea" style="width: 100%">
              <el-option :label="$t('CargoMsg.Cargo_Domestic')" :value="false" />
              <el-option :label="$t('CargoMsg.Cargo_International')" :value="true" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 中文名称 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')" prop="chineseName">
            <el-input v-model="form.chineseName" no="chineseName" :maxlength="200" />
          </el-form-item>
        </el-col>
        <!-- 简称 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.shortName')" prop="shortName">
            <el-input v-model="form.shortName" no="shortName" :maxlength="100" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 英文名称 -->
        <el-col :span="12">
          <el-form-item :label="$t('baseInfo.partner.englishName')" prop="englishName">
            <el-input v-model="form.englishName" no="englishName" :maxlength="200" />
          </el-form-item>
        </el-col>
        <!-- 是否同行 -->
        <el-col :span="12">
          <el-form-item :label="$t('Partners.isPeers')" prop="peer">
            <el-select v-model="form.peer" no="peer" style="width: 100%">
              <el-option :label="$t('Message.Yes')" :value="true" />
              <el-option :label="$t('Message.No')" :value="false" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 有无合同 -->
        <el-col :span="12">
          <el-form-item :label="$t('CargoMsg.Cargo_ContractStatus2')" prop="signContract">
            <el-select v-model="form.signContract" no="signContract" style="width: 100%">
              <el-option :label="$t('CargoMsg.Cargo_NoContract')" :value="false" />
              <el-option :label="$t('CargoMsg.Cargo_HasContract')" :value="true" />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 地址 -->
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Addr')" prop="address">
            <el-input v-model="form.address" no="address" :maxlength="500" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 角色 -->
      <el-form-item :label="$t('CargoMsg.Cargo_RuleRole')" style="padding-top:10px">
        <el-row :gutter="20">
          <el-col :span="5" style="margin-left: -10px">
            <el-checkbox v-model="form.bookingAgent">{{ $t('SeaExport.BookingOrExchangeAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.seaCmpAgent">{{ $t('SeaExport.CarrierAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.overseaAgent">{{ $t('Payment.destinationAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.designationAgent">{{ $t('queryJob.nominatedAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.localAgent">{{ $t('SeaExport.LocalAgent') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-checkbox v-model="form.settlementAgent">{{ $t('Payment.settlementAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.seaCmp">{{ $t('SeaExport.ShippingCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.airCmp">{{ $t('SeaExport.AirlineCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.customsBroker">{{ $t('SeaExport.CustomsBroker') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.warehouse">{{ $t('SeaExport.Warehouse') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-checkbox v-model="form.truckCmp">{{ $t('Partners.isTruckCmp') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.shipper">{{ $t('Message.Shipper') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.consignee">{{ $t('Message.Consignee') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.notify">{{ $t('Message.Notify') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.portAgent">{{ $t('Partners.portAgent') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-checkbox v-model="form.forwardingAgent">{{ $t('Partners.forwardingAgent') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.loadingPlaceCompany">{{ $t('Partners.loadingPlaceCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.signBillPlaceCompany">{{ $t('Partners.signBillPlaceCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.terminalCompany">{{ $t('Message.TerminalCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.dischargePortCompany">{{ $t('Partners.dischargePortCompany') }}</el-checkbox>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="5">
            <el-checkbox v-model="form.destinationPortCompany">{{ $t('Partners.destinationPortCompany') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.tradersSign">{{ $t('Partners.traders') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.factorySign">{{ $t('Partners.Factory')+'/'+$t('Order.Producer') }}</el-checkbox>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="form.other">{{ $t('Message.Other') }}</el-checkbox>
          </el-col>
        </el-row>
      </el-form-item>
      <!-- 相关业务类型 -->
      <el-form-item :label="$t('Partners.relatedBusinessType')" prop="relatedBusinessTypes">
        <el-checkbox v-model="form.seaExport" no="seaExport">{{ $t('constant.systemConstants.SE') }}</el-checkbox>
        <el-checkbox v-model="form.seaImport" no="seaImport">{{ $t('constant.systemConstants.SI') }}</el-checkbox>
        <el-checkbox v-model="form.airExport" no="airExport">{{ $t('constant.systemConstants.AE') }}</el-checkbox>
        <el-checkbox v-model="form.airImport" no="airImport">{{ $t('constant.systemConstants.AI') }}</el-checkbox>
        <el-checkbox v-model="form.railwayExport" no="railwayExport">{{ $t('constant.systemConstants.RB') }}</el-checkbox>
        <el-checkbox v-model="form.integratedJob" no="integratedJob">{{ $t('constant.systemConstants.IE') }}</el-checkbox>
      </el-form-item>
      <!-- 供应商档案 -->
      <el-form-item :label="$t('CargoMsg.Cargo_SupplierFile')" prop="customerProfile">
        <div class="upload-file-row">
          <template v-if="hasUploadedFile('customerProfile')">
            <span class="upload-file-name">{{ getUploadedFileName('customerProfile') }}</span>
            <el-button class="upload-file-remove" type="text" icon="el-icon-close" @click="handleRemoveUpload('customerProfile')" />
          </template>
          <el-button v-else size="small" type="primary" @click="handleUpload('customerProfile')">
            {{ $t('CargoMsg.Cargo_Upload') }}
          </el-button>
        </div>
      </el-form-item>
      <!-- 审批内容简述 -->
      <el-form-item :label="$t('CargoMsg.Cargo_ApprovalSummary')" prop="applicationReason" required>
        <el-input
          v-model="form.applicationReason"
          type="textarea"
          :rows="4"
          :maxlength="500"
          show-word-limit
          no="applicationReason"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: 0 auto; width: fit-content;">
      <el-button type="primary" no="submit" @click="handleSubmit">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="uploadSuccess"
    />
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CompanyApplication } from '@/class/model/mdm/CompanyApplication'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import DropUploader from '@/components/Cargo/Common/DropUploader.vue'
import { Project } from '@/class/model/pm/Project'
import { addCompanyApplicationFunc, checkCompanyExistFunc } from '@/api/company'

export default {
  name: 'SupplierApplicationDialog',
  components: { DropUploader, cargoCloudFileUpload, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    const validateRelatedBusinessTypes = (rule, value, callback) => {
      if (!(this.form.seaExport || this.form.seaImport || this.form.airExport || this.form.airImport || this.form.railwayExport || this.form.integratedJob)) {
        callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelectBusinessType')))
      } else {
        callback()
      }
    }
    const validateFile = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(this.$t('CargoMsg.Cargo_PleaseSelectFile')))
      } else {
        callback()
      }
    }
    return {
      innerVisible: false,
      form: new CompanyApplication().fillDefaultValue().getData(),
      selectTypeNames: TYPE_NAMES,
      rules: {
        oversea: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        chineseName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        cnShortName: [
          { required: false, trigger: 'blur' }
        ],
        shortName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        englishName: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ],
        peer: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        signContract: [
          { required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect'), trigger: 'change' }
        ],
        relatedBusinessTypes: [
          { required: true, validator: validateRelatedBusinessTypes, trigger: 'change' }
        ],
        customerProfile: [
          { required: true, validator: validateFile, trigger: 'change' }
        ],
        applicationReason: [
          { required: true, message: this.$t('CargoMsg.Cargo_PlsInput'), trigger: 'blur' }
        ]
      },
      uploadedFiles: {
        customerProfile: []
      },
      cloudFile: {
        visible: false,
        type: 'customerProfile',
        job: new Project(),
        lob: 'allLob'
      }
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.initData()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async initData() {
      // 重置表单
      this.resetForm()
    },
    resetForm() {
      this.form = {
        oversea: false,
        customer: false,
        ifCustomer: false,
        ifSupplier: true,
        chineseName: '',
        englishName: '',
        shortName: '',
        cnShortName: '',
        address: '',
        overseasWarehouse: false,
        peer: false,
        tradeTypes: '',
        customerTypeId: 1,
        creditDateLimited: 0,
        credit: 0,
        signContract: false,
        latestContractDate: '',
        // 业务类型相关字段
        seaExport: false,
        seaImport: false,
        airExport: false,
        airImport: false,
        railwayExport: false,
        integratedJob: false,
        // 角色类型相关字段
        settlementAgent: false,
        bookingAgent: false,
        seaCmpAgent: false,
        overseaAgent: false,
        designationAgent: false,
        localAgent: false,
        seaCmp: false,
        airCmp: false,
        customsBroker: false,
        warehouse: false,
        truckCmp: false,
        signBillPlaceCompany: false,
        shipper: false,
        consignee: false,
        notify: false,
        portAgent: false,
        forwardingAgent: false,
        terminalCompany: false,
        loadingPlaceCompany: false,
        dischargePortCompany: false,
        destinationPortCompany: false,
        tradersSign: false,
        factorySign: false,
        other: false,
        // 附件相关字段
        creditSelfAssessment: '',
        customerProfile: '',
        customerCommission: '',
        // 审批相关字段
        applicationReason: ''
      }
      this.uploadedFiles = {
        customerProfile: []
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 打开文件上传
    handleUpload(fileType) {
      this.cloudFile.type = fileType
      this.cloudFile.visible = true
    },
    hasUploadedFile(fileType) {
      return !!(this.form[fileType] && this.form[fileType].length > 0)
    },
    getUploadedFileName(fileType) {
      const files = (this.uploadedFiles && this.uploadedFiles[fileType]) || []
      const names = files.map(f => f && f.fileName).filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveUpload(fileType) {
      this.form[fileType] = ''
      if (this.uploadedFiles && this.uploadedFiles[fileType]) {
        this.uploadedFiles[fileType] = []
      }
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.clearValidate) {
          this.$refs.form.clearValidate(fileType)
        }
      })
    },
    async uploadSuccess(data) {
      try {
        const list = []
        const fileInfoList = []
        for (const item of data) {
          if (item.fileId) {
            list.push(item.fileId)
            fileInfoList.push({
              fileId: item.fileId,
              fileName: item.fileName || item.name || ''
            })
          }
        }
        if (this.cloudFile.type === 'customerProfile') {
          this.form.customerProfile = list.join(',')
          this.uploadedFiles.customerProfile = fileInfoList
        }
        this.$nextTick(() => {
          if (this.$refs.form && this.$refs.form.validateField) {
            this.$refs.form.validateField(this.cloudFile.type)
          }
        })
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    // 提交表单
    async handleSubmit() {
      console.log('form--------------', this.form)
      this.$refs.form.validate(async(valid) => {
        if (!valid) {
          // this.$message.warning(this.$t('CargoMsg.Cargo_RequiredFields'))
          return false
        }
        const payload = {
          branchId: 1,
          chineseName:
          this.form.chineseName,
          englishName: this.form.englishName,
          cnShortName: this.form.cnShortName,
          isCustomer: false
        }
        const checkRes = await checkCompanyExistFunc(payload)
        if (checkRes && checkRes.ok && checkRes.data) {
          this.$message.warning(this.$t('CargoMsg.Cargo_AlreadyExistsCannotSubmit', [checkRes.data]))
          return
        }
        const loading = getLoading4Cxt(this)
        try {
          const res = await addCompanyApplicationFunc(this.form)
          if (res.ok) {
            this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
            this.innerVisible = false
          } else {
            this.$message.error(this.$t('CargoMsg.Cargo_SubmitException'))
          }
        } finally {
          loading.close()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.supplier-application-form {
  ::v-deep .el-form-item {
    margin-bottom: 15px !important;
  }
}
::v-deep .el-form-item__label {
  font-weight: 500;
}

::v-deep .el-checkbox-group {
  .el-checkbox {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}

::v-deep .el-textarea {
  .el-textarea__inner {
    font-family: inherit;
  }
}

.upload-file-row {
  display: flex;
  align-items: center;
}

.upload-file-name {
  max-width: 560px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.upload-file-remove {
  padding: 0 4px;
  margin-left: 6px;
  line-height: 1;
}
</style>
